import { Box } from "@mui/material";
import React, { JSX } from "react";
import styles from "./DetailPage.subComponents.module.scss";

export const ContentWrapper = React.memo(
  (props: { children?: JSX.Element[] }) => (
    <Box className={styles.contentWrapper}>{props.children}</Box>
  )
);
